/**
 * Reviews carousel: arrow buttons scroll one card at a time, and each review shows "Read more"
 * only when its text is actually cut off.
 */

const ROOT = '.reviews';

/** @param {HTMLElement} root */
function updateArrows(root) {
  const track = root.querySelector('.reviews__track');
  const prev = root.querySelector('.reviews__arrow--prev');
  const next = root.querySelector('.reviews__arrow--next');
  if (!(track instanceof HTMLElement) || !(prev instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) {
    return;
  }

  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
}

/** Shows the Read more button only for reviews that are cut off. */
function updateReadMore() {
  document.querySelectorAll(`${ROOT} .review-card`).forEach((card) => {
    const text = card.querySelector('.review-card__text');
    const more = card.querySelector('.review-card__more');
    if (!(text instanceof HTMLElement) || !(more instanceof HTMLElement)) return;

    if (card.classList.contains('review-card--open')) {
      more.hidden = false;
      return;
    }

    more.hidden = text.scrollHeight <= text.clientHeight + 1;
  });
}

function refresh() {
  document.querySelectorAll(ROOT).forEach((root) => root instanceof HTMLElement && updateArrows(root));
  updateReadMore();
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const arrow = target.closest('.reviews__arrow');
  if (arrow instanceof HTMLButtonElement) {
    const root = arrow.closest(ROOT);
    const track = root?.querySelector('.reviews__track');
    const card = track?.querySelector('.review-card');
    if (!(track instanceof HTMLElement) || !(card instanceof HTMLElement)) return;

    const step = card.getBoundingClientRect().width + 12;
    track.scrollBy({ left: arrow.classList.contains('reviews__arrow--prev') ? -step : step, behavior: 'smooth' });
    return;
  }

  const more = target.closest('.review-card__more');
  if (more instanceof HTMLElement) {
    const card = more.closest('.review-card');
    if (!card) return;
    const open = card.classList.toggle('review-card--open');
    more.textContent = open ? 'Read less' : 'Read more';
    updateReadMore();
  }
});

document.addEventListener(
  'scroll',
  (event) => {
    const track = event.target;
    if (track instanceof HTMLElement && track.classList.contains('reviews__track')) {
      const root = track.closest(ROOT);
      if (root instanceof HTMLElement) updateArrows(root);
    }
  },
  true
);

window.addEventListener('resize', refresh);

// Layout can settle after the first run (fonts, images): keep the arrows and Read more buttons in step.
new ResizeObserver(refresh).observe(document.documentElement);
window.addEventListener('load', refresh);
if (document.readyState !== 'loading') refresh();
else document.addEventListener('DOMContentLoaded', refresh);
